import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

/**
 * Intercepts sidebar link clicks to strip the /en locale prefix
 * that next-intl may inject, keeping internal navigation clean.
 */
export function useNavigationIntercept() {
  const router = useRouter()

  useEffect(() => {
    const handleClick = (e: Event) => {
      const target = e.target as HTMLElement
      const link = target.closest('a')

      if (link && link.href) {
        const url = new URL(link.href)
        if (url.origin === window.location.origin && url.pathname.startsWith('/en')) {
          e.preventDefault()
          const cleanPath = url.pathname.replace(/^\/en/, '') || '/'
          router.push(cleanPath)
        }
      }
    }

    const sidebar = document.querySelector('.sidebar')
    if (sidebar) {
      sidebar.addEventListener('click', handleClick)
      return () => sidebar.removeEventListener('click', handleClick)
    }

    return undefined
  }, [router])
}
